const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { icd: icdApi } = require('@doctoroncallcom/api')
const {
  GET_ICD_LIST,
  GET_ICD,
  CREATE_ICD,
  UPDATE_ICD,
  DELETE_ICD,
} = require('./constants')

const {
  getIcdListSuccess,
  getIcdListError,
  getIcdSuccess,
  getIcdError,
  createIcdSuccess,
  createIcdError,
  updateIcdSuccess,
  updateIcdError,
  deleteIcdSuccess,
  deleteIcdError,
} = require('./actions')

const getIcdList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ICD_LIST),
  mergeMap(action => icdApi.getIcdListApi(api, {
    take: action.payload.take,
    skip: action.payload.skip,
    search: action.payload.search,
  })
    .then(response => getIcdListSuccess(response.data))
    .catch(error => getIcdListError(error))),
)

const getIcd = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ICD),
  mergeMap(action => icdApi.getIcdApi(api, action.payload.id)
    .then(response => getIcdSuccess(response.data))
    .catch(error => getIcdError(error))),
)

const createIcd = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_ICD),
  mergeMap(action => icdApi.createIcdApi(api, action.payload.icdData)
    .then(response => createIcdSuccess(response.data))
    .catch(error => createIcdError(error))),
)

const updateIcd = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ICD),
  mergeMap(action => icdApi.updateIcdApi(api, action.payload.id, action.payload.icdData)
    .then(response => updateIcdSuccess(response.data))
    .catch(error => updateIcdError(error))),
)

const deleteIcd = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_ICD),
  mergeMap(action => icdApi.deleteIcdApi(api, action.payload.id)
    .then(response => deleteIcdSuccess(response.data))
    .catch(error => deleteIcdError(error))),
)

module.exports = {
  getIcdList,
  getIcd,
  createIcd,
  updateIcd,
  deleteIcd,
}
